// function to time picker
(function () {
  const hoursInput = document.getElementById("hours");
  const minutesInput = document.getElementById("minutes");
  const secondsInput = document.getElementById("seconds");
  const amBtn = document.getElementById("amBtn");
  const pmBtn = document.getElementById("pmBtn");

  // Set default time to 5 minutes from now
  function setDefaultTime() {
    const now = new Date();
    now.setMinutes(now.getMinutes() + 5);

    let hours = now.getHours();
    const minutes = now.getMinutes();
    const seconds = now.getSeconds();

    const isPM = hours >= 12;
    if (hours === 0) hours = 12;
    else if (hours > 12) hours -= 12;

    hoursInput.value = String(hours).padStart(2, "0");
    minutesInput.value = String(minutes).padStart(2, "0");
    secondsInput.value = String(seconds).padStart(2, "0");

    toggleAMPM(isPM ? "PM" : "AM");
  }

  // AM/PM toggle logic
  function toggleAMPM(period) {
    if (period === "AM") {
      amBtn.classList.add("active");
      pmBtn.classList.remove("active");
    } else {
      pmBtn.classList.add("active");
      amBtn.classList.remove("active");
    }
  }

  amBtn.addEventListener("click", () => toggleAMPM("AM"));
  pmBtn.addEventListener("click", () => toggleAMPM("PM"));

  setDefaultTime();
})();

// function to calender
(function () {
  const calendarDates = document.querySelector(".calendar-dates");
  const monthYear = document.getElementById("month-year");
  const prevMonthBtn = document.getElementById("prev-month");
  const nextMonthBtn = document.getElementById("next-month");

  const today = new Date();
  today.setHours(0, 0, 0, 0); // normalize
  let currentMonth = today.getMonth();
  let currentYear = today.getFullYear();
  let selectedDate = null;

  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  function renderCalendar(month, year) {
    calendarDates.innerHTML = "";
    monthYear.textContent = `${months[month]} ${year}`;

    const firstDay = new Date(year, month, 1).getDay();
    const daysInMonth = new Date(year, month + 1, 0).getDate();

    // Add blank cells before the first day
    for (let i = 0; i < firstDay; i++) {
      const blank = document.createElement("div");
      calendarDates.appendChild(blank);
    }

    for (let i = 1; i <= daysInMonth; i++) {
      const date = new Date(year, month, i);
      const day = document.createElement("div");
      day.textContent = i;

      const isToday =
        date.getDate() === today.getDate() &&
        date.getMonth() === today.getMonth() &&
        date.getFullYear() === today.getFullYear();

      const isSelected =
        selectedDate &&
        date.getDate() === selectedDate.getDate() &&
        date.getMonth() === selectedDate.getMonth() &&
        date.getFullYear() === selectedDate.getFullYear();

      const isPast = date < today;

      if (isPast) {
        day.style.color = "#ccc";
        day.style.cursor = "not-allowed";
      } else {
        day.style.cursor = "pointer";
        day.addEventListener("click", () => {
          selectedDate = new Date(year, month, i);
          renderCalendar(month, year);
        });
      }

      if (isToday) day.classList.add("today");
      if (isSelected) day.classList.add("selected");

      calendarDates.appendChild(day);
    }

    // ✅ Disable going back before current month
    const isAtMinMonth =
      month === today.getMonth() && year === today.getFullYear();
    prevMonthBtn.disabled = isAtMinMonth;

    // ❌ No limit on future navigation now
    nextMonthBtn.disabled = false;
  }

  renderCalendar(currentMonth, currentYear);

  prevMonthBtn.addEventListener("click", () => {
    const isAtMinMonth =
      currentMonth === today.getMonth() && currentYear === today.getFullYear();

    if (!isAtMinMonth) {
      currentMonth--;
      if (currentMonth < 0) {
        currentMonth = 11;
        currentYear--;
      }
      renderCalendar(currentMonth, currentYear);
    }
  });

  nextMonthBtn.addEventListener("click", () => {
    currentMonth++;
    if (currentMonth > 11) {
      currentMonth = 0;
      currentYear++;
    }
    renderCalendar(currentMonth, currentYear);
  });
})();

// function to pop-up
(function () {
  const openPopUp = document.getElementById("schedule-btn");
  const openCallPopUp = document.getElementById("call-now-btn");
  const closePopUp = document.getElementById("closePopUp");
  const closeCallPopUp = document.getElementById("closeCallPopUp");

  openPopUp.addEventListener("click", () => {
    const popUpContainer = document.querySelector(".pop-up-container");
    popUpContainer.classList.add("open");
  });

    closePopUp.addEventListener("click", () => {
    const popUpContainer = document.querySelector(".pop-up-container");
    popUpContainer.classList.remove("open");
  });

    openCallPopUp.addEventListener("click", () => {
       const callPopUpContainer = document.querySelector(".pop-up-container.call-pop-up-container");
    callPopUpContainer.classList.add("open");
  });

  closeCallPopUp.addEventListener("click", () => {
     const callPopUpContainer = document.querySelector(".pop-up-container.call-pop-up-container");
    callPopUpContainer.classList.remove("open");
  });
})();



// function to get name, phone, email, today date, selected day and time

(function () {
  const nameInput = document.querySelector("#userName");
  const phoneInput = document.querySelector("#userPhone");
  const emailInput = document.querySelector("#userEmail");
  const todayDate = document.querySelector(".calendar-dates .today");
  const selectedHour = document.querySelector(".time-picker #hours");
  const selectedMinute = document.querySelector(".time-picker #minutes");
  const selectedSeconds = document.querySelector(".time-picker #seconds");
  const amPm = document.querySelector(".ampm-toggle .active");
  const monthYear = document.querySelector(".calendar-header #month-year");

  const bookCallBtn = document.querySelector("#bookCallBtn");

  bookCallBtn.addEventListener("click", () => {
    if (!validateForm()) return;
    const selectedDay = document.querySelector(".calendar-dates .selected");
    const name = nameInput.value;
    const phone = phoneInput.value;
    const email = emailInput.value;
    const today = todayDate.textContent;
    const selected = selectedDay?.textContent || today;
    const hour = selectedHour.value;
    const minute = selectedMinute.value;
    const seconds = selectedSeconds.value;
    const amPmValue = amPm.textContent;

    const time = `${hour}:${minute}:${seconds} ${amPmValue}`;

    const monthYearValue = monthYear.textContent;
    const month = monthYearValue.split(" ")[0];
    const year = monthYearValue.split(" ")[1];
    const date = `${month} ${selected}, ${year}`;

    const appointmentData = {
      name,
      phone,
      email,
      date,
      time,
      amPmValue,
    };

    console.log(appointmentData);
  });

  function validateForm() {
    if (nameInput.value === "") {
      nameInput.parentElement.classList.add("error");
      removeErrorMessage(nameInput.parentElement);
      nameInput.parentElement.appendChild(
        createErrorMessage("Please enter your name")
      );
    } else {
      nameInput.parentElement.classList.remove("error");
      removeErrorMessage(nameInput.parentElement);
    }
    if (phoneInput.value === "") {
      phoneInput.parentElement.classList.add("error");
      removeErrorMessage(phoneInput.parentElement);
      phoneInput.parentElement.appendChild(
        createErrorMessage("Please enter your phone number")
      );
    } else {
      phoneInput.parentElement.classList.remove("error");
      removeErrorMessage(phoneInput.parentElement);
    }
    // if (emailInput.value === "") {
    //   emailInput.parentElement.classList.add("error");
    //   removeErrorMessage(emailInput.parentElement);
    //   emailInput.parentElement.appendChild(
    //     createErrorMessage("Please enter your email")
    //   );
    // } else {
    //   emailInput.parentElement.classList.remove("error");
    //   removeErrorMessage(emailInput.parentElement);
    // }
    return true;
  }
  
    function createErrorMessage(message) {
    const errorElement = document.createElement("span");
    errorElement.classList.add("error-message");
    errorElement.textContent = message;
    return errorElement;
  }

  function removeErrorMessage(parentElement) {
    const errorElement = parentElement.querySelector(".error-message");
    if (errorElement) {
      errorElement.remove();
    }
  }
})();




(function () {
  const nameInput = document.querySelector(".call-pop-up-container #userName");
  const phoneInput = document.querySelector(".call-pop-up-container #userPhone");
  const emailInput = document.querySelector(".call-pop-up-container #userEmail");

  const getCallNowBtn = document.querySelector("#getCallNowBtn");

  bookCallBtn.addEventListener("click", () => {
    if (!validateForm()) return;
    const name = nameInput.value;
    const phone = phoneInput.value;
    const email = emailInput.value;
  

    const appointmentData = {
      name,
      phone,
      email,
    };

    console.log("Call Now:", appointmentData);
  });

  getCallNowBtn.addEventListener("click", () => {
    if (!validateForm()) return;
    const name = nameInput.value;
    const phone = phoneInput.value;
    const email = emailInput.value;

    const appointmentData = {
      name,
      phone,
      email,
    };

    console.log(appointmentData);
  });

  function validateForm() {
    if (nameInput.value === "") {
      nameInput.parentElement.classList.add("error");
      removeErrorMessage(nameInput.parentElement);
      nameInput.parentElement.appendChild(
        createErrorMessage("Please enter your name")
      );
    } else {
      nameInput.parentElement.classList.remove("error");
      removeErrorMessage(nameInput.parentElement);
    }
    if (phoneInput.value === "") {
      phoneInput.parentElement.classList.add("error");
      removeErrorMessage(phoneInput.parentElement);
      phoneInput.parentElement.appendChild(
        createErrorMessage("Please enter your phone number")
      );
    } else {
      phoneInput.parentElement.classList.remove("error");
      removeErrorMessage(phoneInput.parentElement);
    }
    // if (emailInput.value === "") {
    //   emailInput.parentElement.classList.add("error");
    //   removeErrorMessage(emailInput.parentElement);
    //   emailInput.parentElement.appendChild(
    //     createErrorMessage("Please enter your email")
    //   );
    // } else {
    //   emailInput.parentElement.classList.remove("error");
    //   removeErrorMessage(emailInput.parentElement);
    // }
    return true;
  }
  
    function createErrorMessage(message) {
    const errorElement = document.createElement("span");
    errorElement.classList.add("error-message");
    errorElement.textContent = message;
    return errorElement;
  }

  function removeErrorMessage(parentElement) {
    const errorElement = parentElement.querySelector(".error-message");
    if (errorElement) {
      errorElement.remove();
    }
  }
})();

